<template>
  <div>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="TURNOS" key="1">
          <g-master name="shift_setup"
                    :endpoint="shiftMaster.endpoint"
                    :tableSetup="shiftMaster.tableSetup"
                    :modalFieldsSetup="shiftMaster.modalFieldsSetup"
                    :useMultipart="true"
                    modalWidth="90%"
          >
            <template slot="masterModal" slot-scope="{record}">

              <a-row :gutter="[48, 24]">

                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Tipo turno">
                    <a-input
                      v-decorator="['id_shift', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="H. inicio del turno: ">
                    <a-time-picker style="width: 100%" use12Hours format="h:mm:a"
                                   v-decorator="['start_time', { type: 'object', rules: [{ required: true, message: 'Valor requerido' }]}]"
                                   placeholder="H. inicio"
                    />
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item label="H. fin del turno: " v-bind="fiOptions">
                    <a-time-picker style="width: 100%" use12Hours format="h:mm:a"
                                   v-decorator="['end_time', { type: 'object', rules: [{ required: true, message: 'Valor requerido' }] }]"
                                   placeholder="H. fin"
                    />
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Activo: " :has-feedback="false">
                    <a-checkbox
                      v-decorator="['status', {valuePropName: 'checked' , rules: [{ required: true, message: 'Valor requerido' }]}]">
                    </a-checkbox>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Cant. horas diurnas: ">
                    <a-input v-decorator="['daily_hours', { rules: [{ required: false}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Cant. horas nocturnas: ">
                    <a-input v-decorator="['night_hours', { rules: [{ required: false}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Cant. horas extra diurna: ">
                    <a-input v-decorator="['extra_daily_hours', { rules: [{ required: false}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Cant. horas extra nocturna: ">
                    <a-input v-decorator="['extra_night_hours', { rules: [{ required: false}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Editable: " :has-feedback="false">
                    <a-checkbox v-decorator="['allow_edit', {valuePropName: 'checked'}]">
                    </a-checkbox>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="H. diurnas diarias inicial: ">
                    <a-input
                      v-decorator="['daily_hours_day_ini', { rules: [{ required: false}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="H. diurnas diarias extra: ">
                    <a-input
                      v-decorator="['daily_hours_extra_day_ini', { rules: [{ required: false}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="H. noturnas diarias extra: ">
                    <a-input
                      v-decorator="['nigth_hours_extra_day_ini', { rules: [{ required: false}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="H. diurnas dia final: ">
                    <a-input
                      v-decorator="['daily_hours_day_end', { rules: [{ required: false}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="H. nocturnas dia inicial: ">
                    <a-input
                      v-decorator="['nigth_hours_day_ini', { rules: [{ required: false}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="H. nocturnas dia final: ">
                    <a-input
                      v-decorator="['nigth_hours_day_end', { rules: [{ required: false}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="H. extra diurnas dia final: ">
                    <a-input
                      v-decorator="['daily_hours_extra_day_end', { rules: [{ required: false}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="H. extra nocturna dia final: ">
                    <a-input
                      v-decorator="['nigth_hours_extra_day_end', { rules: [{ required: false}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="# H. recargo nocturno: ">
                    <a-input
                      v-decorator="['hours_night_21_22', { rules: [{ required: false}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              label="Diurno o nocturno: "
                              :formItemConfig="fiOptions"
                              :decorator="['overtime_type',{ rules: [{ required: false, message: 'Valor requerido' }]}]"
                              :params="id_h_rol_params">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item label="Descripción" v-bind="fiOptions">
                    <a-input
                      v-decorator="['description', { rules: [{ required: false}] }]"/>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
        </a-tab-pane>
      </a-tabs>
    </a-row>
  </div>
</template>

<script>

  export default {
    name: "ShiftSetup",
    data() {
      return {
        id_h_rol_params: {
          h_lookup_type: 'TIPO_TIEMPO_EXTRA'
        },
        colOptions: {xs: 12, sm: 8},
        fiOptions: {
          'label-col': {span: 12},
          'wrapper-col': {span: 12},
          'has-feedback': true
        },
        areaOptions: {
          'wrapper-col': {span: 24},
          'has-feedback': true
        },
        shiftMaster: {
          endpoint: 'shift_setup',
          tableSetup: {
            tableConfig: { //
              rowKey: 'id',
            },
            columns: [
              {title: 'IDENTIFICADOR DEL TURNO', dataIndex: 'id_shift', sorter: true},
              {title: 'HORA INICIO DEL TURNO', dataIndex: 'start_time', sorter: true},
              {title: 'HORA FIN DEL TURNO', dataIndex: 'end_time', sorter: true},
              {title: 'DESCRIPCION DEL TURNO', dataIndex: 'description', sorter: true},
              {title: 'H. DIURNAS', dataIndex: 'daily_hours', sorter: true},
              {title: 'H. NOCTURNAS', dataIndex: 'night_hours', sorter: true},
              {title: 'H. EXTRA DIURNA', dataIndex: 'extra_daily_hours', sorter: true},
              {title: 'CANTIDAD DE HORAS EXTRA NOCTURNA', dataIndex: 'extra_night_hours', sorter: true},
              {title: 'ESTADO', dataIndex: 'allow_status_desc', sorter: true},
              {title: 'PERMITE EDITAR', dataIndex: 'allow_edit_desc', sorter: true},
              {title: 'H. DIURNA DIA INICIO', dataIndex: 'daily_hours_day_ini', sorter: true},
              {title: 'H. NOCTURNA DIA INICIO', dataIndex: 'nigth_hours_day_ini', sorter: true},
              {title: 'H. EXTRA DIURNA DIA INICIO', dataIndex: 'daily_hours_extra_day_ini', sorter: true},
              {
                title: 'H. EXTRA NOCTURNA DIA INICIO',
                dataIndex: 'nigth_hours_extra_day_ini',
                sorter: true
              },
              {title: 'H. DIURNA DIA FINAL', dataIndex: 'daily_hours_day_end', sorter: true},
              {title: 'H. NOCTURNA DIA FINAL', dataIndex: 'nigth_hours_day_end', sorter: true},
              {title: 'H. EXTRA DIURNA DIA FINAL', dataIndex: 'daily_hours_extra_day_end', sorter: true},
              {
                title: 'H. EXTRA NOCTURNA DIA FINAL',
                dataIndex: 'nigth_hours_extra_day_end',
                sorter: true
              },
              {title: '# HORAS RECARGO NOCTURNO 9 A 10 PM', dataIndex: 'hours_night_21_22', sorter: true},
              {title: 'DIURNO (D) O NOCTURNO (N)', dataIndex: 'overtime_type_desc', sorter: true},
            ]
          },
          actions: {
            actions: [
              {
                name: 'masterEdit',
                text: 'Editar',
                permisos: [],
                props: {size: 'small', type: 'link', icon: 'edit'}
              },
              {
                name: 'masterDelete',
                text: 'Eliminar',
                permisos: [],
                props: {size: 'small', icon: 'delete', type: 'link'}
              }
            ]
          },
          allowSelect: true,
          selectedRows: [],
          modalFieldsSetup: [
            {name: 'id_shift'},
            {name: 'start_time', type: 'time'},
            {name: 'end_time', type: 'time'},
            {name: 'description'},
            {name: 'daily_hours'},
            {name: 'night_hours'},
            {name: 'extra_daily_hours'},
            {name: 'extra_night_hours'},
            {name: 'status'},
            {name: 'allow_edit'},
            {name: 'daily_hours_day_ini'},
            {name: 'daily_hours_extra_day_ini'},
            {name: 'nigth_hours_extra_day_ini'},
            {name: 'daily_hours_day_end'},
            {name: 'nigth_hours_day_end'},
            {name: 'daily_hours_extra_day_end'},
            {name: 'hours_night_21_22'},
            {name: 'overtime_type'},
            {name: 'nigth_hours_extra_day_end'},
            {name: 'nigth_hours_day_ini'}
          ]
        },
      }
    },
    mounted() {
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Shift/ShiftSetup.vue